export default "__VITE_ASSET__K9h9$nMu__";